module.exports = __webpack_public_path__ + "8cc783cf1bc7046fea3c3588f06e4387.svg";